import { useMutation }                 from '@apollo/client'
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/20/solid'
import { useDispatch }                 from 'react-redux'
import { Link }                        from 'react-router-dom'
import { setToasts, showToaster }      from '../../features/toaster/toasterSlice'
import { DELETE_LOCATION }             from '../../graphql/location'
import { LoadingEllipsis }             from '../Loaders'

export default function LocationsTableItem( props: any ): JSX.Element {
  const { location, currentUser, refetch } = props
  const dispatch: any                      = useDispatch()

  const [ deleteLocation, { loading: deleting } ] = useMutation( DELETE_LOCATION, {
    onCompleted: async (): Promise<void> => {
      await refetch()
      dispatchMessage( 'success', 'Location deleted!' )
    },
    onError:     ( error: any ): void => console.log( error )
  } )

  const dispatchMessage: any = ( type: string, message: string ): void => {
    dispatch( setToasts( [ { id: '1', type, message } ] ) )
    dispatch( showToaster( true ) )
  }

  const handleDelete: any = ( e: any ): void => {
    e.preventDefault()

    if ( window.confirm( 'Are you sure you want to delete this Location?' ) ) {
      deleteLocation( { variables: { input: { id: location.id } } } )
    }
  }

  const locationAddress: any = ( location: any ): string => {
    const parts = [
      location.address_line1,
      location.address_line2,
      location.address_city,
      location.address_county,
      location.address_postcode
    ]

    return parts.filter( Boolean ).join( ', ' )
  }

  return (
    <>
      { deleting && <LoadingEllipsis klass="bg-white ellipse-yellow ellipse-xl p-4" /> }
      { !deleting &&
        <div className={ `bg-white rounded-2xl p-2 2xl:p-4 w-full grid grid-locations-table-cols-admin gap-4` }>
          <div className="flex items-center text-blue-header">
            <span>{ location.name }</span>
          </div>

          <div className="flex items-center">
            { location.email &&
              <a href={ `mailto:${ location.email }` }>
                <span className="text-blue-500 hover:text-blue-700 break-words">{ location.email }</span>
              </a>
            }
          </div>

          <div className="flex items-center text-blue-header">{ locationAddress( location ) }</div>

          <div className="flex justify-center items-center">
            <Link to={ `/locations/edit/${ location.id }` } className="flex p-0 mr-3 text-blue-secondary hover:text-blue-secondary-darker">
              <PencilSquareIcon className="w-4 h-4" />
            </Link>

            { currentUser.email === 'dawid@denfield.co.uk' &&
              <button
                className="p-0 float-right hover:text-red-600"
                color="default"
                onClick={ handleDelete }
              >
                <TrashIcon className="w-4 h-4" />
              </button>
            }
          </div>
        </div>
      }
    </>
  )
}
